import { create } from "zustand";
import { api } from "api";
import { usePersistentFetch } from "../utils/usePersistentFetch";

const useStore = create((set) => ({
  variables: [],
  isFetched: false,
  setVariables: (variables) => set({ variables, isFetched: true }),
}));

export const useWeatherVariables = () => {
  const setVariables = useStore((state) => state.setVariables);
  const variables = useStore((state) => state.variables);
  const isFetched = useStore((state) => state.isFetched);

  const { fetchState } = usePersistentFetch({
    isFetched,
    setStoreData: setVariables,
    fetchFn: api.weather.variables,
    queryKey: "variables",
  });

  return { variables, fetchState };
};
